import omit from 'lodash/omit';
import features, {
    ZG_API,
    DEV_BRAND,
} from 'app/shared/constants/FeatureFlagConstants';

// JSON.parse converts "true" to boolean true, and "false" to boolean false
// override with query if necessary
const getServices = (cookies = {}, query = {}) => {
    const isProd = process.env.ZG_ENV === 'production-docker';
    const ret = {};
    let availableFeatures = features;

    if (isProd) {
        availableFeatures = omit(availableFeatures, [ZG_API, DEV_BRAND]);
    }

    Object.keys(availableFeatures).forEach((feature) => {
        let featureValue = features[feature];

        if (cookies[feature]) {
            featureValue = cookies[feature];
        }

        if (query[feature]) {
            featureValue = query[feature];
        }

        try {
            ret[feature] = JSON.parse(featureValue); // booleans
        } catch (error) {
            ret[feature] = featureValue; // strings
        }
    });

    return ret;
};

export { getServices };
